import { useRequestEvent } from "#imports";
export function useLogger() {
  const event = useRequestEvent();
  if (event) {
    return event.context.logger;
  }
  return window.logger;
}
